/**
 * Created by Yangxunwu on 2018/6/19.
 */

import Cookies from "js-cookie"

/**
 * 获取键名的值
 * @param key
 * @returns {null}
 */
export function getItem(key) {
	
	let item = window.localStorage.getItem(key);

	return item === null ? null : JSON.parse(item);
}

/**
 * 设置值
 * @param key
 * @param value
 */
export function setItem(key, value) {
	return window.localStorage.setItem(key, JSON.stringify(value));
}

/**
 * 删除
 * @param key
 */
export function deleteItem(key) {
	window.localStorage.removeItem(key);
}

/**
 * 清除所有存储数据
 */
export function clear() {
	window.localStorage.clear();
}


// WEBPACK FOOTER //
// ./src/utils/storage.js